import { useTranslation } from 'react-i18next'

import { Alert } from '@reveni-io/reveni-ui'

import { earningsWarningCopies } from '@/metrics/pages/PerformanceInsightsPage/GlobalTab/EarningsSection/YourEarningsCard/constants'

const EarningsWarning = ({ scenario }) => {
  const { t } = useTranslation()

  return <Alert type="warning">{t(earningsWarningCopies[scenario])}</Alert>
}

export default EarningsWarning
